import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroOverview from "../components/HeroOverview";
import ProductPortfolio from "../components/ProductPortfolio";
import GlamurPaintFeatures from "../components/GlamurPaintFeatures";
import PaintExcellenceSection from "../components/PaintExcellenceSection";
import FAQoverview from "../components/FAQoverview";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
export default function Productoverview() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <HeroOverview />
      <ProductPortfolio />
      <GlamurPaintFeatures />
      <PaintExcellenceSection />
      <FAQoverview />
      <Footer />
      <ScrollToTopButton />
    </>
  );
}
